import { render, staticRenderFns } from "./MonitoringDashboard.vue?vue&type=template&id=19079c0e&scoped=true"
import script from "./MonitoringDashboard.vue?vue&type=script&lang=js"
export * from "./MonitoringDashboard.vue?vue&type=script&lang=js"
import style0 from "./MonitoringDashboard.vue?vue&type=style&index=0&id=19079c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19079c0e",
  null
  
)

export default component.exports